import { invoiceEndPoints } from "../constants/endpoints";
import { api } from "./api";
import { getApiOrganizationId } from "../utils/orgIdUtils";

export const getInvoiceDetails = async (orderId: string) => {
  try {
    return await api.get(`${invoiceEndPoints.getInvoiceDetails}/${orderId}`, {
      headers: {
        orgId: getApiOrganizationId(),
      },
    });
  } catch (error) {
    throw new Error("Failed to fetch customers");
  }
};

export const updateInvoice = async (
  orderId: string,
  customerExecLeafNo: string,
  transporterPermitNo: string,
  transporter: string,
  vehicleNumber: string,
  exciseID: string,
  serviceID?: string | null
) => {
  try {
    return await api.put(
      `${invoiceEndPoints.updateInvoice}/${orderId}`,
      {
        customerExecLeafNo: customerExecLeafNo,
        transporterPermitNo: transporterPermitNo,
        transporter: transporter,
        vehicleNumber: vehicleNumber,
        exciseID: exciseID,
        serviceID,
      },
      {
        headers: {
          orgId: getApiOrganizationId(),
        },
      }
    );
  } catch (error: any) {
    throw new Error(
      error?.response?.data?.error?.type ?? "Failed to update invoice"
    );
  }
};

export type InvoiceDataType = {
  bank: {
    accountName?: string;
    accountNumber?: string;
    name?: string;
    branchCode?: string;
    ifscCode?: string;
    address?: string;
  };
  billTo: {
    licenseName?: string;
    licenseAddress?: string;
    licensePANNumber?: string;
    licenseGSTNumber?: string;
    gstStateCode?: string;
  };
  company: {
    cin?: string;
    email?: string;
    factoryAddress?: string;
    gst?: string;
    gstStateCode?: string;
    name?: string;
    pan?: string;
    registeredAddress?: string;
    tel?: string;
    signature?: string;
    logo?: string;
    logo_s?: string;
  };
  seller_details?: {
    name?: string;
    email?: string;
    phone?: string;
    gst?: string;
    pan?: string;
    cin?: string;
    stateCode?: string;
    registeredAddress?: string;
  };
  customer_details?: {
    licenseName?: string;
    licenseAddress?: string;
    pan?: string;
    gst?: string;
    stateCode?: string;
  };
  excise: {
    exciseID?: string;

    products?: {
      name?: string;
      unitKeg?: number;
      unitRate?: number;
      kegNos?: number;
      liters?: number;
      amount?: number;
      exciseDuty?: number;
      additionalExciseDuty?: number;
      subTotal?: number;
      exciseDutyPerL: number;
      edPerKeg: number;
      aedPerKeg: number;
    }[];
    liters?: number;
    kegNos?: number;
    subTotal?: number;
    tcs?: number;
    grandTotal?: number;
    amountInWords?: string;
    placeOfSupply?: string;
  };
  service: {
    serviceID?: string | null;
    liters?: number;
    preTaxAmount?: number;
    sgst?: number;
    cgst?: number;
    hsn?: string;
    grandTotal?: number;
    roundOff?: number;
    amountInWords?: string;
    outstandingAmount?: number;
  };
  other: {
    outletName?: string;
    registeredAddress?: string;
    clientCIN?: string;
    clientGST?: string;
    clientGSTStateCode?: string;
    clientPAN?: string;
    invoiceId?: string;
    customerExecLeafNo?: string;
    transporterPermitNo?: string;
    transporter?: string;
    invoiceDate?: string;
    exciseRegistrationNumber?: string;
    vehicleNumber?: string;
  };
  invoiceId?: string;
  includeService?: boolean;
  outstandingAmount?: number;
};

export const fetchInvoices = async ({
  page,
  limit,
  searchTerm,
  startDate,
  endDate,
  sortOrder,
}: any) => {
  return api.get("/bulk-download-invoices", {
    params: {
      page,
      limit,
      searchTerm,
      startDate,
      endDate,
      sortOrder,
    },
    headers: {
      orgId: getApiOrganizationId(),
    },
  });
};
